<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
  import store from "@/store";
  import { firebaseAuth, firestore } from "@/firebase";

  export default {
    data() {
      return {
        unsubscribeAuthStateListener: null,
        unsubscribeUserListener: null
      }
    },
    created() {
      this.unsubscribeAuthStateListener = firebaseAuth.onAuthStateChanged(user => {
        let isLoggedIn = !!(user || {}).uid;
        store.dispatch('authStateChanged', { loggedIn: isLoggedIn });

        if (isLoggedIn) {
          this.unsubscribeUserListener = firestore.collection('users').doc(user.uid).onSnapshot(userSnapshot => {
            store.dispatch('userChanged', { id: userSnapshot.id, ...userSnapshot.data() });
          });
        } else {
          store.dispatch('userChanged', null);
          this.unsubscribeUserListener();
        }
      });
    },
    beforeDestroy() {
      this.unsubscribeAuthStateListener();
      this.unsubscribeUserListener();
    }
  }
</script>

<style>
  @import url("https://fonts.googleapis.com/css?family=Muli");
  #app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
  }
  body {
    margin: 0;
    height: 100vh;
  }

</style>
